export const PHONE_NUMBER = '+12129944953';
export const EMAIL_RECIPIENT = 'expert@platformart.com';
